import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const autopilot = defineConnector({
  identifier: "autopilot",
  name: "Autopilot",
  tagLine: "Marketing automation",
  logo,
  protocol: "http",
  tags: ["communication"],
  defaultUrlPattern: () => "https://api2\\.autopilothq\\.com/.*",
  auth: (app) =>
    headerAuth([{ name: "autopilotapikey", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Get your API key",
      items: [
        {
          kind: "markdown",
          content:
            "In [Autopilot](https://www.autopilothq.com/), go to **Settings → Autopilot API** to find your API key.",
        },
      ],
    },
    {
      title: "Enter your API key",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api2.autopilothq.com/v1/account",
  },
});
